import { Button } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';

import { useSxStyles } from '~/components/SolaForceDataGrid/components/ButtonCellComponent/useStyles';

type PropsType = GridRenderCellParams & {
  onClick: (value: GridRenderCellParams) => void;
};

export const ButtonCellComponent = (props: PropsType) => {
  const { onClick, ...params } = props;
  const { value } = params;

  const sxStyles = useSxStyles();

  return (
    <Button
      onClick={() => {
        onClick(params);
      }}
      fullWidth={true}
      sx={sxStyles.cellButton}
    >
      {value}
    </Button>
  );
};
